import { BankAccountCreationData } from '../../../types/data/BankAccountCreationData';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import React from 'react';

export interface BankAccountNewModalRecapStepProps {
  creationData: BankAccountCreationData;

  onCancelClicked: () => void;
  onSubmit: () => void;
}

export const BankAccountNewModalRecapStep = (
  props: BankAccountNewModalRecapStepProps,
) => {
  return (
    <>
      <DialogContent>
        <List sx={{ position: 'relative', maxHeight: 400 }}>
          <ListItem>
            <ListItemText
              primary={'Fichier'}
              secondary={props.creationData.fileName}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={'Dossier'}
              secondary={props.creationData.folderFileId}
            />
          </ListItem>
          <Divider />
          {[1, 2, 3, 4, 5].map((item) => (
            <ListItem key={item}>
              <ListItemText primary={'TODO'} secondary={'A faire'} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          color={'primary'}
          type={'button'}
          onClick={props.onCancelClicked}
        >
          Précédent
        </Button>
        <Button color={'primary'} type={'button'} onClick={props.onSubmit}>
          Créer le compte
        </Button>
      </DialogActions>
    </>
  );
};
